import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Callback from '@/routes/Main/Login/LoginCallback';
import * as serviceWorker from './serviceWorker';
import * as utils from '@/components/utils';
import ActivationCallback from './routes/Main/Login/ActivationCallback';
import { keycloak } from './config';

const queryUrl = window.location.search;
const paramUrl = new URLSearchParams(queryUrl);
if (paramUrl.get('activation') === 'user' && paramUrl.get('key')) {
  ReactDOM.render(<ActivationCallback />, document.getElementById('root'));
} else {
  keycloak.instance
    .init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
    })
    .then(authenticated => {
      const userInfo: any = keycloak.instance.tokenParsed;
      if (authenticated && userInfo) {
        utils.setStorage('US_TokenParsed', JSON.stringify(userInfo));
        ReactDOM.render(<Callback />, document.getElementById('root'));
      } else {
        ReactDOM.render(<App />, document.getElementById('root'));
      }
    });
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
